import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { AsyncAutocomplete } from './AsyncAutocomplete';
import { StaticOptionField } from './StaticOptionField';

export const KeywordField = ({ watch, field, control, setValue }) => {
  const mainKeyword = watch('keywordKey');
  const [keywordOptions, setKeywordOptions] = useState([]);

  useEffect(() => {
    if (!mainKeyword) {
      setValue('keywordKey', null);
      setValue('keywordValue', null);
    }

    mainKeyword && keywordOptions?.length && setValue('keywordValue', null);

    setKeywordOptions(
      mainKeyword?.keywordOptions?.map(data => ({
        label: data,
        value: data,
      })) || []
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainKeyword]);

  const { keywordKey, keywordValue } = field;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(156px, 1fr))',
        gap: '10px',
        gridColumn: 'span 2',
      }}>
      <AsyncAutocomplete
        field={keywordKey.field}
        label={keywordKey.label}
        control={control}
        optionsMap={data => {
          return data.map(data => ({
            label: data.key,
            value: data.key,
            deleted: data?.deleted ?? false,
            keywordOptions: data.values,
          }));
        }}
        requestUrl={keywordKey.requestUrl}
        responseKey={keywordKey.responseKey}
      />

      <StaticOptionField
        label={keywordValue.label}
        field={keywordValue.field}
        control={control}
        options={keywordOptions}
        disabled={!keywordOptions?.length}
      />
    </Box>
  );
};
